import React, { PropTypes, Component } from 'react';
import InputField from 'shared-components/FormFields/Input';
import validations from 'modules/validations';
import validForPromoCheck from '../lib/validForPromoCheck';
import classes from '../index.scss';
import CloseGray from 'shared-components/Svg/CloseGray';
import cx from 'classNames';
import { stages, errorMsg } from '../lib/constants';

class Initial extends Component {
  state = {
    valid: undefined,
    error: undefined,
    value: '',
    validating: false,
  }

  onFocus = () => {
    this.setComponentState();
  }

  onBlur = (e, val) => {
    this.setState({ value: val });
  }

  setComponentState(valid = undefined, error = undefined) {
    this.setState({
      valid,
      error,
    });
  }

  keyDown = (e, val) => {
    if (e.key === 'Enter') {
      this.validate(val);
    }
  }

  validate = (val) => {
    const value = typeof(val) === 'string' ? val : this.state.value;
    const validFormat = validations.email(value);

    if (validFormat) {
      this.setState({ validating: true });
      validForPromoCheck(value, this.props.csrfToken).then((response) => {
        if (response.statusCode === 201) this.props.callback(stages.Success);
        else this.props.callback(stages.Invalid);
      });
    } else {
      this.setComponentState(false, errorMsg);
    }
  }

  closeModal = () => {
    this.props.callback(stages.Close);
  }

  render() {
    const fieldProps = {
      input: {
        name: 'user[email]',
        placeholder: 'Email Address',
      },
      error: this.state.error,
      valid: this.state.valid,
      label: '',
      type: 'email',
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      onKeyDown: this.keyDown,
    };
    const validating = cx({
      [classes.validating]: this.state.validating,
    });

    return (
      <div>
        <div className={validating}></div>
        <div className={classes.close} onClick={this.closeModal}>{CloseGray()}</div>
        <p className={classes.title}>Get $10 off</p>
        <p className={classes.subtitle}>when you purchase $25 or more</p>
        <InputField {...fieldProps} />
        <div className={classes.button} onClick={this.validate}>
          <p>I want $10</p>
        </div>
        <div className={classes.reject}>
          <p onClick={this.closeModal}>
            No thanks
          </p>
        </div>
        <p className={classes.terms}>Valid on first-time purchases only. $25 minimum order. Limit one-time use. Cannot be combined with additional offers. One redemption and one account per household.
         <a href='https://www.raise.com/raise-rewards-terms' target='_blank'>
           Terms apply.
         </a>
       </p>
      </div>
    );
  }
}

Initial.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
};

export default Initial;



/** WEBPACK FOOTER **
 ** ./apps/emailPromoModal/components/Initial.js
 **/